import { createRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { z } from 'zod';
import { Route as rootRoute } from '../__root';
import { Button } from '../../components/Button';
import { type OnboardingSession } from '../../lib/queries/onboarding';
import StepIndicator from '../../components/new-tenants/StepIndicator';
import Step1Info from '../../components/new-tenants/Step1Info';
import Step2Provision from '../../components/new-tenants/Step2Provision';
import Step3Verify from '../../components/new-tenants/Step3Verify';

const searchSchema = z.object({
  step: z.coerce.number().catch(1),
});

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/customers/new',
  validateSearch: searchSchema,
  component: NewCustomerPage,
});

function NewCustomerPage() {
  const { step } = Route.useSearch();
  const navigate = useNavigate();
  const [session, setSession] = useState<OnboardingSession | null>(null);

  const goTo = (s: number) =>
    navigate({ to: '/customers/new', search: { step: s } });

  return (
    <div className="flex flex-col items-center px-6 py-10">
      <div className="w-full max-w-4xl">
        <StepIndicator current={step} />
        <div className="rounded-lg border border-white/8">
          {step === 1 && (
            <Step1Info
              onNext={(s) => {
                setSession(s);
                goTo(2);
              }}
            />
          )}
          {step === 2 && session && (
            <Step2Provision
              session={session}
              onNext={() => goTo(3)}
              onBack={() => goTo(1)}
            />
          )}
          {step === 3 && session && (
            <Step3Verify session={session} onBack={() => goTo(2)} />
          )}

          {!session && step > 1 && (
            <div className="py-8 text-center">
              <p className="text-muted mb-4 text-sm">
                Session lost — please start over.
              </p>
              <Button onClick={() => goTo(1)}>Start over</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
